import BaseService from '@/api/base'

class AuthService extends BaseService {
  constructor () {
    super('auth')
  }

  getPasswordPolicy () {
    return this.get('settings/password-policy')
  }

  getMfASettings () {
    return this.get('settings/mfa-settings')
  }

  updateMfaConfiguration (newMfaSettings) {
    return this.put('settings/mfa-settings', newMfaSettings)
  }
}

export default new AuthService()
